import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItalicIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <path
        d="M3.33337 15.3333L3.72537 13.4433H5.68804L7.95671 2.55929H5.99404L6.38604 0.666626H12.6667L12.2747 2.55929H10.312L8.04337 13.4433H10.006L9.61404 15.3333H3.33337Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItalicIcon.displayName = 'ItalicIcon';
